/**
 * 某项后端能力是否开放（GET /api/v1/features，任务 37）：先按开放显示，读到关闭后再隐藏（接口不通按开放，保持原样）。
 */
import { ref, type Ref } from 'vue'
import { getFeatures, type FeatureKey } from '@/api/features'

export function useFeature(key: FeatureKey): Ref<boolean> {
  const on = ref(true)
  void getFeatures().then(f => { on.value = f[key] })
  return on
}

/** ChatBI V3 下线时要藏起来的菜单 key（「我的看板」：收藏的看板都由仪表板生成产出） */
export const CHATBI_V3_MENU_KEYS: ReadonlySet<string> = new Set(['my-dashboards'])
